var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 160,
    viewBox: "0 0 400 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_244_7789)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 160,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.474 87.5015L216.169 93.2186L210.111 105.054L191.474 87.5015Z",
    fill: "#E56953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 143.787C118 143.787 141.042 133.776 148.683 137.845C153.25 140.276 154.154 145.796 151.362 149.335C149.21 152.062 146.104 152.41 142.464 151.769C134.755 150.412 134.872 139.68 137.966 133.034C142.239 123.857 164.918 129.273 164.918 129.273",
    stroke: "#52D6C0",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.017 -10.1282L105.728 -4.73341C99.3559 -2.48484 92.8613 -7.61969 93.6303 -14.2987C94.3233 -20.3176 90.5955 -27.1233 83.4131 -24.5404C77.7995 -22.5217 72.0977 -27.1819 73.0021 -33.0495",
    stroke: "#89C8FF",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.623 118.173L306.221 130.354C305.637 135.432 299.993 138.144 295.708 135.407C291.847 132.94 285.984 133.218 285.359 138.957C284.87 143.442 279.812 145.773 276.123 143.212",
    stroke: "#CFF0FF",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0002 60L56.0765 61.6198C61.9436 62.295 65.0778 68.8166 61.9149 73.7683C59.0646 78.2307 59.3855 85.0047 66.0168 85.7276C71.1997 86.2926 73.8931 92.1375 70.9347 96.4",
    stroke: "#89C8FF",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.049,
    y: 67.6597,
    width: 15.0402,
    height: 5.85855,
    transform: "rotate(117 339.049 67.6597)",
    fill: "#DAD0FB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.5,
    y: 44,
    width: 13.492,
    height: 5.25547,
    transform: "rotate(-93 303.5 44)",
    fill: "#F3E34A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.643,
    y: 36.5981,
    width: 18.3579,
    height: 7.15088,
    transform: "rotate(-138 173.643 36.5981)",
    fill: "#DAD0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 112C217.673 112 232 97.6731 232 80C232 62.3269 217.673 48 200 48C182.327 48 168 62.3269 168 80C168 97.6731 182.327 112 200 112Z",
    fill: "#00A63E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.733 111.246C207.346 111.127 207.956 110.99 208.562 110.835C209.589 110.548 210.601 110.21 211.594 109.822C212.588 109.437 213.563 109.002 214.514 108.52C215.465 108.036 216.392 107.505 217.29 106.928C218.187 106.352 219.055 105.73 219.89 105.067C220.727 104.403 221.529 103.697 222.295 102.952C223.06 102.209 223.787 101.429 224.474 100.614C225.161 99.7975 225.808 98.9476 226.41 98.0669C227.012 97.1878 227.57 96.2791 228.082 95.3443C228.594 94.4081 229.058 93.4469 229.474 92.4643C229.89 91.4814 230.257 90.4784 230.573 89.4589C230.843 88.5664 231.074 87.6624 231.266 86.7496L212.253 67.7389C210.647 66.1261 208.738 64.8468 206.636 63.9745C204.534 63.1022 202.28 62.6542 200.005 62.6563C197.727 62.6538 195.471 63.1015 193.367 63.9738C191.262 64.8461 189.351 66.1256 187.743 67.7389C186.131 69.3475 184.852 71.2582 183.98 73.3617C183.107 75.4653 182.658 77.7202 182.658 79.9976C182.658 82.2749 183.107 84.5299 183.98 86.6335C184.852 88.737 186.131 90.6477 187.743 92.2563L206.733 111.246Z",
    fill: "#008532"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.002 62.6587C204.434 62.6587 208.866 64.352 212.258 67.7414C213.87 69.3499 215.149 71.2607 216.021 73.3642C216.894 75.4677 217.343 77.7227 217.343 80C217.343 82.2774 216.894 84.5324 216.021 86.6359C215.149 88.7394 213.87 90.6501 212.258 92.2587C210.649 93.8708 208.738 95.1498 206.635 96.0225C204.531 96.8951 202.276 97.3443 199.999 97.3443C197.722 97.3443 195.467 96.8951 193.363 96.0225C191.26 95.1498 189.349 93.8708 187.74 92.2587C186.128 90.6501 184.849 88.7394 183.977 86.6359C183.104 84.5324 182.655 82.2774 182.655 80C182.655 77.7227 183.104 75.4677 183.977 73.3642C184.849 71.2607 186.128 69.3499 187.74 67.7414C189.348 66.1281 191.26 64.8485 193.364 63.9762C195.468 63.104 197.724 62.6562 200.002 62.6587ZM207.895 74.664C207.643 74.6882 207.402 74.7834 207.202 74.9387L197.458 82.2454L192.943 77.7334C191.964 76.7147 190.036 78.64 191.058 79.6187L196.391 84.952C196.622 85.1707 196.922 85.3026 197.239 85.3255C197.557 85.3483 197.872 85.2606 198.132 85.0774L208.799 77.0774C209.695 76.424 209.143 74.6827 208.034 74.6667C207.988 74.6644 207.943 74.6644 207.898 74.6667L207.895 74.664Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_244_7789"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 160,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.287249a63cc57d8bd8050361fefbe8c9.svg";
export { ForwardRef as ReactComponent };